/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export interface AddressTranslations {
    apartment_number_placeholder: string;
    copy_from_billing_address: string;
    building_number_placeholder: string;
    street_name_placeholder: string;
    city_placeholder: string;
    postcode_placeholder: string;
    suburb_placeholder: string;
    region_placeholder: string;
    country_loading_placeholder: string;
    country_select_placeholder: string;
    countries_load_error: string;
}
